import buildRedirectUrls from './buildRedirectUrls';
import { RedirectFlow, GATEWAY_FLOW_TYPE } from './constants';

export default function buildGatewayPayload({ flowType, userPayload }) {
    if (flowType === GATEWAY_FLOW_TYPE.CREDIT_CARD) {
        return {
            ...userPayload,
            ...buildRedirectUrls(),
            [RedirectFlow.PaymentQueryParamName]: RedirectFlow.QueryParamPaymentId,
        };
    }
    if (flowType === GATEWAY_FLOW_TYPE.REDIRECT) {
        return {
            ...buildRedirectUrls(),
            [RedirectFlow.PaymentQueryParamName]: RedirectFlow.QueryParamPaymentId,
        };
    }

    throw new Error(`Flow type '${flowType}' not implemented`);
}
